'use client';

import { useEffect } from 'react';

const GlobalError = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    if (window) {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      window.dataLayer.push({
        event: 'error_message',
        message: error.digest || error.message,
      });
    }
  }, []);

  return (
    <html lang="en">
      <body>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <h2>Something went wrong!</h2>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <button type="button" onClick={() => reset()}>
          Try again
        </button>
      </body>
    </html>
  );
};

export default GlobalError;
